export default "__VITE_ASSET__1b2f9c45__"